// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2897 ? "sentry" : chunkId) + ".legacy." + {"2897":"be2d255930859de00c54","3490":"9fcc7a9ed8fae0ae5607"}[chunkId] + ".js";
};